"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconPrinter', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M17,14 L15,14 L15,12 C15,11.447 14.553,11 14,11 L6,11 C5.447,11 5,11.447 5,12 L5,14 L3,14 L3,8 L6,8 L14,8 L17,8 L17,14 Z M7,17 L13,17 L13,13 L7,13 L7,17 Z M7,6 L13,6 L13,3 L7,3 L7,6 Z M18,6 L15,6 L15,2 C15,1.447 14.553,1 14,1 L6,1 C5.447,1 5,1.447 5,2 L5,6 L2,6 C1.447,6 1,6.447 1,7 L1,15 C1,15.553 1.447,16 2,16 L5,16 L5,18 C5,18.553 5.447,19 6,19 L14,19 C14.553,19 15,18.553 15,18 L15,16 L18,16 C18.553,16 19,15.553 19,15 L19,7 C19,6.447 18.553,6 18,6 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;